import React, { useState } from 'react';
import { Presentation } from './components/Presentation';
export function App() {
  return <div className="w-full min-h-screen bg-[#f7f3ef]" data-id="element-0">
      <Presentation data-id="element-1" />
    </div>;
}